import { useEffect, useRef } from "react";

interface InfoDialogueCompProps {
  show: boolean;
  title?: string;
  message: string;
  onClose: () => void;
}

const InfoDialogueComp: React.FC<InfoDialogueCompProps> = ({ show, title = "Info", message, onClose }) => {
  const modalRef = useRef<HTMLDivElement | null>(null);
  const bsModalRef = useRef<any>(null);

  useEffect(() => {
    if (modalRef.current) {
      bsModalRef.current = new (window as any).bootstrap.Modal(modalRef.current);
      modalRef.current.addEventListener('hidden.bs.modal', onClose);
    }
    return () => {
      modalRef.current?.removeEventListener('hidden.bs.modal', onClose);
    };
  }, []);

  useEffect(() => {
    if (show) {

      bsModalRef.current?.show();
    } else {
      bsModalRef.current?.hide();
    }
  }, [show]);
  
  return (
    <div className="modal fade" tabIndex={-1} ref={modalRef} data-bs-backdrop="static" data-bs-keyboard="false" >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={() => bsModalRef.current?.hide()}></button>
          </div>
          <div className="modal-body">
            <p>{message}</p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-dark  rounded-0" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoDialogueComp;
